import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import { Button } from "rsuite";
import { QRCodeCanvas } from "qrcode.react";
import HeaderOfPage from "../tools/headerOfPage";

interface BreadcrumbItem {
    id: string;
    name: string;
}

export default function ListProductsGroup() {
    const { t } = useTranslation();
    const [parent, setParent] = useState<string>("");
    const [parentName, setParentName] = useState<string>("");
    const [breadcrumbPath, setBreadcrumbPath] = useState<BreadcrumbItem[]>([]);
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
        } catch (e) {
            console.error('Error loading languages:', e);
            setLanguages([
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ]);
        }
    };

    useEffect(() => {
        loadLanguages();
    }, []);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'Products Group List',
            url: null
        },
    ]

    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }

    const setParents = (id: string, name?: string) => {
        setParent(id);
        let x = key2 + 1;
        setKey2(x);
        
        if (id && name) {
            setParentName(name);
            setBreadcrumbPath(prev => [...prev, { id, name }]);
        } else {
            setParentName("");
            setBreadcrumbPath([]);
        }
    }

    const goToParent = (index: number) => {
        if (index === -1) {
            setParent("");
            setParentName("");
            setBreadcrumbPath([]);
        } else {
            const newPath = breadcrumbPath.slice(0, index + 1);
            setBreadcrumbPath(newPath);
            if (newPath.length > 0) {
                const target = newPath[newPath.length - 1];
                setParent(target.id);
                setParentName(target.name);
            } else {
                setParent("");
                setParentName("");
            }
        }
        let x = key + 1;
        setKey(x);
    }

    const [key, setKey] = useState(1);
    const [key2, setKey2] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Products Group List"></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1" dir="rtl">
                        <NewGroupCategory 
                            parent={parent} 
                            parentName={parentName}
                            key={key2} 
                            reloaditem={reloadgame}
                            languages={languages}
                        />
                    </div>
                    <div className="lg:col-span-3">
                        <ListofBlog 
                            setParents={setParents} 
                            parent={parent} 
                            parentName={parentName}
                            breadcrumbPath={breadcrumbPath}
                            goToParent={goToParent}
                            key={key}
                            languages={languages}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

function ListofBlog({ parent, setParents, parentName, breadcrumbPath, goToParent, languages = [] }: { parent?: string; setParents: (id: string, name?: string) => void; parentName?: string; breadcrumbPath: BreadcrumbItem[]; goToParent: (index: number) => void; languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<any>(null);
    const [reordering, setReordering] = useState<string | null>(null);
    
    // Language selector state - default to Persian (fa)
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const [activeLang, setActiveLang] = useState<string>('fa'); // Default to Persian
    
    // Set default language when languages are loaded
    useEffect(() => {
        if (langList.length > 0) {
            // Find Persian (fa) in the list, or use first available
            const faLang = langList.find(l => l.code === 'fa');
            setActiveLang(faLang ? 'fa' : langList[0].code);
        }
    }, [languages.length]);

    // Helper function to safely extract error message
    const getErrorMessage = (error: any, fallback: string): string => {
        const responseMessage = error?.response?.data?.message;
        if (typeof responseMessage === 'string') {
            return responseMessage;
        } else if (responseMessage && typeof responseMessage === 'object') {
            if (responseMessage.message && typeof responseMessage.message === 'string') {
                return responseMessage.message;
            }
        }
        return fallback;
    };

    const getalldata = async (p: string) => {
        setLoading(true);
        setError(null);
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup?parent=' + (p || ''),
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(res.data.message);
        } catch (error: any) {
            const errorMessage = getErrorMessage(error, 'خطا در بارگذاری اطلاعات');
            setError(errorMessage);
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage || t('Error loading data'),
            });
        } finally {
            setLoading(false);
        }
    }

    const orderttop = async (id: any) => {
        setReordering(id);
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/pgroup/orderup/' + id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            getalldata(parent || '');
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Order changed successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: getErrorMessage(error, t('Error changing order')),
            });
        } finally {
            setReordering(null);
        }
    }

    const orderdown = async (id: any) => {
        setReordering(id);
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/pgroup/orderdown/' + id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            getalldata(parent || '');
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Order changed successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: getErrorMessage(error, t('Error changing order')),
            });
        } finally {
            setReordering(null);
        }
    }

    // Helper function to get multilingual value
    const getMultilingualValue = (field: any, lang: string): string => {
        if (!field) return '';
        if (typeof field === 'string') return field;
        if (typeof field === 'object') {
            return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
        }
        return '';
    };

    const getLoadNew = async (id: any, name: any) => {
        try {
            // Handle multilingual name - extract display name based on active language
            const displayName = getMultilingualValue(name, activeLang);
            setParents(id, displayName);
        } finally {
            getalldata(id);
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/pgroup/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Group deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    getalldata(parent || '');
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: getErrorMessage(error, t('Error deleting group')),
                    });
                }
            }
        });
    }

    useEffect(() => {
        getalldata(parent || '');
    }, [parent]);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    return (
        <div className="space-y-4" dir="rtl">
            {/* Breadcrumb Navigation */}
            <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center gap-2 flex-wrap">
                    <button
                        onClick={() => {
                            goToParent(-1);
                            getalldata('');
                        }}
                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        ریشه
                    </button>
                    {breadcrumbPath.map((item: BreadcrumbItem, index: number) => (
                        <div key={item.id} className="flex items-center gap-2">
                            <span className="text-gray-400">/</span>
                            <button
                                onClick={() => {
                                    goToParent(index);
                                    getalldata(item.id);
                                }}
                                className="px-3 py-1 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors"
                            >
                                {item.name}
                            </button>
                        </div>
                    ))}
                    {parentName && (
                        <div className="flex items-center gap-2">
                            <span className="text-gray-400">/</span>
                            <span className="px-3 py-1 text-sm font-semibold text-gray-800 bg-blue-50 rounded">
                                {parentName}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {/* Action Buttons */}
            <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-3 flex-wrap">
                        <button
                            type="button"
                            onClick={() => {
                                goToParent(-1);
                                getalldata('');
                            }}
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                بازگشت به ریشه
                            </div>
                        </button>
                        <button
                            type="button"
                            onClick={() => getalldata(parent || '')}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                {t('Reload')}
                            </div>
                        </button>
                    </div>
                    <div className="flex items-center gap-3 flex-wrap">
                        {/* Language Selector */}
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-gray-700">زبان:</span>
                            <div className="flex gap-2 flex-wrap">
                                {langList.map((lang) => (
                                    <button
                                        key={lang.code}
                                        type="button"
                                        onClick={() => setActiveLang(lang.code)}
                                        className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                            activeLang === lang.code
                                                ? 'bg-blue-600 text-white'
                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                        }`}
                                    >
                                        {lang.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {parentName && (
                            <div className="text-sm text-gray-600">
                                در حال مشاهده زیرگروه‌های: <span className="font-semibold text-gray-800">{parentName}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Groups Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {error && (
                    <div className="p-4 bg-red-50 border-r-4 border-red-500 text-red-700">
                        {typeof error === 'string' ? error : 'خطا در بارگذاری اطلاعات'}
                    </div>
                )}
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('بارکد')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('ترتیب')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {list && list.length > 0 ? (
                                list.map((item: any) => {
                                    // Handle multilingual name display based on active language
                                    const displayName = getMultilingualValue(item.name, activeLang);
                                    const displayUrl = getMultilingualValue(item.url, activeLang);
                                    return (
                                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-6 py-4">
                                            <div className="flex items-center">
                                                <div>
                                                    <div className="text-sm font-medium text-gray-900">{displayName || 'بدون نام'}</div>
                                                    <div className="text-sm text-gray-500 mt-1">Code: {item.code || 'N/A'}</div>
                                                    <div className="text-sm text-gray-500 mt-1">URL: {displayUrl || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex justify-center">
                                                <QRCodeCanvas 
                                                    value={`https://nanosealco.com/group/${item.url}`}
                                                    size={80}
                                                    level="H"
                                                />
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    onClick={() => orderttop(item.id)}
                                                    disabled={reordering === item.id}
                                                    className="p-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                    title="جابجایی به بالا"
                                                >
                                                    {reordering === item.id ? (
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                                    ) : (
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                        </svg>
                                                    )}
                                                </button>
                                                <button
                                                    onClick={() => orderdown(item.id)}
                                                    disabled={reordering === item.id}
                                                    className="p-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                    title="جابجایی به پایین"
                                                >
                                                    {reordering === item.id ? (
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                                    ) : (
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    )}
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    onClick={() => getLoadNew(item.id, item.name)}
                                                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
                                                    title="مشاهده زیرگروه‌ها"
                                                >
                                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                                    </svg>
                                                    {t('Subgroup')}
                                                </button>
                                                <a
                                                    href={`/dashboard/Products/ProductsGroup/${item.id}`}
                                                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                                                    title="ویرایش"
                                                >
                                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg>
                                                    {t('Edit')}
                                                </a>
                                                <button
                                                    onClick={() => deleted(item.id)}
                                                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                                                    title="حذف"
                                                >
                                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                    {t('Delete')}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={4} className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center">
                                            <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                            </svg>
                                            <p className="text-gray-500 text-lg">گروهی یافت نشد</p>
                                            {parent && (
                                                <p className="text-gray-400 text-sm mt-2">این گروه زیرگروهی ندارد</p>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

type MultilingualField = Record<string, string>;

const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
    if (!field) {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    }
    if (typeof field === 'string') {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = field);
        return obj;
    }
    if (typeof field === 'object') {
        const obj: MultilingualField = { ...field };
        languageCodes.forEach(code => { if (obj[code] == null) obj[code] = ''; });
        return obj;
    }
    const obj: MultilingualField = {};
    languageCodes.forEach(code => obj[code] = '');
    return obj;
};

interface GroupCategoryData {
    name: MultilingualField;
    url: MultilingualField;
    code: string;
    keywords: MultilingualField;
    description: MultilingualField;
    parent: string;
}

function NewGroupCategory({ parent, parentName, reloaditem, languages = [] }: { parent?: string; parentName?: string; reloaditem: () => void; languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const languageCodes = langList.map(l => l.code);

    let cookie = getCookies();
    const [data, setData] = useState<GroupCategoryData>({
        name: {} as MultilingualField,
        url: {} as MultilingualField,
        code: '',
        keywords: {} as MultilingualField,
        description: {} as MultilingualField,
        parent: parent || ''
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState(1);
    const [saving, setSaving] = useState(false);
    const [activeLang, setActiveLang] = useState<string>(langList[0]?.code ?? 'en');

    useEffect(() => {
        if (languageCodes.length === 0) return;
        setData((prev: GroupCategoryData) => ({
            ...prev,
            name: initializeMultilingualField(prev.name, languageCodes),
            url: initializeMultilingualField(prev.url, languageCodes),
            keywords: initializeMultilingualField(prev.keywords, languageCodes),
            description: initializeMultilingualField(prev.description, languageCodes),
        }));
        if (langList[0]) setActiveLang(langList[0].code);
    }, [languageCodes.join(',')]);

    // Helper function to safely extract error message
    const getErrorMessage = (error: any, fallback: string): string => {
        const responseMessage = error?.response?.data?.message;
        if (typeof responseMessage === 'string') {
            return responseMessage;
        } else if (responseMessage && typeof responseMessage === 'object') {
            if (responseMessage.message && typeof responseMessage.message === 'string') {
                return responseMessage.message;
            }
        }
        return fallback;
    };

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: MultilingualField, lang: string): string => {
        return (field && field[lang]) || '';
    };

    // Update parent when prop changes
    useEffect(() => {
        setData((prev: GroupCategoryData) => ({ ...prev, parent: parent || '' }));
    }, [parent]);

    const setName = (name: string) => {
        const updatedName = { 
            ...data.name, 
            [activeLang]: name 
        };
        
        // Generate slug for the active language when typing
        const updatedUrl = { ...data.url };
        updatedUrl[activeLang] = String(changeUrl(name));
        
        setData((prev: GroupCategoryData) => ({ 
            ...prev, 
            url: updatedUrl, 
            name: updatedName
        }));
    }

    const save = async () => {
        setError(null);
        setSaving(true);
        
        try {
            const payload = {
                ...data,
                parent: parent || ''
            };

            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/pgroup',
                data: payload,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Group added successfully'),
                timer: 1500,
                showConfirmButton: false
            });

            // Reset form
            const empty: MultilingualField = {};
            languageCodes.forEach(code => empty[code] = '');
            setData({
                name: { ...empty },
                url: { ...empty },
                code: '',
                keywords: { ...empty },
                description: { ...empty },
                parent: parent || ''
            });
            
            reloaditem();
            let x = key + 1;
            setKey(x);
        } catch (error: any) {
            const errorMessage = getErrorMessage(error, 'خطا در ذخیره گروه');
            setError(errorMessage);
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    return (
        <div className="bg-white rounded-xl shadow-sm p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                {parentName ? `افزودن زیرگروه به "${parentName}"` : 'افزودن گروه جدید'}
            </h3>
            
            {parentName && (
                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800">
                        <strong>گروه والد:</strong> {parentName}
                    </p>
                </div>
            )}

            {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">{typeof error === 'string' ? error : 'خطا در ذخیره گروه'}</p>
                </div>
            )}

            <form key={key} className="space-y-4">
                {/* Language Selector */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        زبان
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {langList.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Name')} ({langList.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={inputstyle}
                        placeholder="نام گروه را وارد کنید"
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Code <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={data.code}
                        className={inputstyle}
                        placeholder="مثال: CAT001"
                        onChange={(e) => setData((prev: GroupCategoryData) => ({ ...prev, code: e.target.value }))}
                        required
                    />
                    <p className="mt-1 text-xs text-gray-500">کد یکتای گروه (به انگلیسی و بدون فاصله)</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Slug ({langList.find(l => l.code === activeLang)?.label})
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.url, activeLang)}
                        className={inputstyle}
                        placeholder="slug"
                        onChange={(e) => setData((prev: GroupCategoryData) => ({ 
                            ...prev, 
                            url: { 
                                ...prev.url, 
                                [activeLang]: e.target.value 
                            } 
                        }))}
                    />
                    <p className="mt-1 text-xs text-gray-500">به صورت خودکار از نام تولید می‌شود (فقط برای زبان انگلیسی)</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Keywords')} ({langList.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        rows={3}
                        className={inputstyle}
                        placeholder="کلمات کلیدی (با کاما جدا کنید)"
                        onChange={(e) => setData((prev: GroupCategoryData) => ({ 
                            ...prev, 
                            keywords: { 
                                ...prev.keywords, 
                                [activeLang]: e.target.value 
                            } 
                        }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Description')} ({langList.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={4}
                        className={inputstyle}
                        placeholder="توضیحات گروه"
                        onChange={(e) => setData((prev: GroupCategoryData) => ({ 
                            ...prev, 
                            description: { 
                                ...prev.description, 
                                [activeLang]: e.target.value 
                            } 
                        }))}
                    />
                </div>

                <button
                    type="button"
                    onClick={save}
                    disabled={saving || !getMultilingualValue(data.name, activeLang) || !data.code}
                    className="w-full py-3 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                >
                    {saving ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            در حال ذخیره...
                        </>
                    ) : (
                        <>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            {parentName ? 'افزودن زیرگروه' : t('Add Category')}
                        </>
                    )}
                </button>
            </form>
        </div>
    )
}
